import React, { useState, useEffect, useMemo, Fragment } from "react";
import { useParams } from "react-router";
import { connect } from "react-redux";
import Loading from "components/Loading";
import { getShopDetail } from "actions/spyAdvancedActions";
import useCallApi from "hook/useCallApi";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import cx from "classnames";
import { Overview, Saleschannels, Productsdistribution, Productlist, Influencerlist, Videolist } from "./detail_tabs";
import { getQueryParams, FlagRegionByIso } from "components/Function";

const ShopDetail = ({ getShopDetail }) => {
    const { filter: initialFilter } = getQueryParams();
    const [filter, setFilter] = useState(initialFilter);
    const { t } = useTranslation();
    const [tab, setTab] = useState("basic");
    const { seller_id } = useParams();
    const params = useMemo(() => ({ ...filter, seller_id }), [filter, seller_id]);
    const { data, loading } = useCallApi(getShopDetail, params);
    const { detail, sale_channel, product_distribution, product_prices, overview, sales_trending_cnt, sales_trending_gmv_amt, influencer_trending, video_trending, products_filters } = data || {};

    useEffect(() => {
        const params = new URLSearchParams({ ...filter });
        window.history.replaceState({}, "", `${window.location.pathname}?${params.toString()}`);
    }, [filter]);

    const onClick = (data) => {
        setTab(data);
    };

    return (
        <Fragment>
            <Loading isLoading={loading} />
            <div className="card">
                <div className="card-body">
                    <div className="d-flex flex-wrap flex-sm-nowrap align-items-center">
                        <div className="me-7 mb-4">
                            <div className="symbol symbol-100px symbol-lg-120px symbol-fixed position-relative overflow-hidden al-border-radius-8">
                                <img src={detail?.images?.[0] || require("components/assets/media/misc/image.png")} alt=""/>
                            </div>
                        </div>
                        <div className="flex-grow-1">
                            <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                                <div className="d-flex flex-column">
                                    <div className="d-flex align-items-center mb-2">
                                        { detail?.shop_type === 1 ? <span className="badge bg-dark text-white rounded-pill pt-1 pb-1 ps-3 pe-3 me-1">Brand</span> : "" }
                                        <Link to="#" className="text-gray-900 text-hover-primary fs-2 fw-bold me-1">{detail?.seller_name}</Link>
                                        <button className="btn btn-link text-hover-primary" data-tooltip-id="my-tooltip"
                                            data-tooltip-content={"Copy"}
                                            onClick={() => navigator.clipboard.writeText(detail?.seller_name)}
                                        >
                                            <i className="ki-duotone ki-copy">
                                            </i>
                                        </button>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 flex-wrap">
                                        {
                                            detail?.region?.key ?
                                                <FlagRegionByIso name={detail?.region?.name} iso={detail?.region?.key} />
                                            : ""
                                        }
                                        <span
                                            data-tooltip-id="my-tooltip"
                                            data-tooltip-content={"Product Experience Points"}
                                            className="badge badge-light-info rounded-pill"
                                        >
                                            {detail?.labels?.rating} / 5.0
                                        </span>
                                        <span
                                            data-tooltip-id="my-tooltip"
                                            data-tooltip-content={"Product Experience Points"}
                                            className="badge badge-light-warning rounded-pill"
                                        >
                                            <img src={require("components/assets/media/custom/cup.svg").default} className="me-1" alt="" />
                                            Daily Ranking {detail?.labels?.ranking}
                                        </span>
                                        { detail?.seller_type.id === 2 ? <span className="badge bg-dark text-warning rounded-pill float-end pt-1 pb-1 ps-3 pe-3" data-tooltip-id="my-tooltip" data-tooltip-content={t("Cross Border")}>CB</span> : "" }
                                    </div>
                                </div>
                                <div className="d-flex my-4">
                                    {
                                        detail?.influencer?.unique_id ?
                                            <div className="border al-border-radius-8 px-4 py-3 d-flex align-items-center gap-3">
                                                <div className="symbol symbol-45px symbol-circle">
                                                    <img src={detail?.images?.[0] || require("components/assets/media/misc/image.png")} alt=""/>
                                                </div>
                                                <div className="d-flex flex-column">
                                                    <div className="fw-bold text-dark">{detail?.influencer?.nick_name}</div>
                                                    <div className="text-muted small">ID: {detail?.influencer?.unique_id}</div>
                                                </div>
                                                <div className="d-flex align-items-center ms-auto gap-3">
                                                    <div className="text-center">
                                                        <div className="fw-bold">{detail?.influencer?.total_followers_cnt}</div>
                                                        <div className="text-muted small">{t("Followers")}</div>
                                                    </div>
                                                    <div className="vr"></div>
                                                    <div className="text-center">
                                                        <div className="fw-bold">{detail?.influencer?.total_digg_cnt}</div>
                                                        <div className="text-muted small">{t("Likes")}</div>
                                                    </div>
                                                    <div className="vr"></div>
                                                    <div className="text-center">
                                                        <div className="fw-bold">{detail?.influencer?.total_video_cnt}</div>
                                                        <div className="text-muted small">{t("Videos")}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        : ""
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="row col">
                            <div className="col-lg-5">
                                <label className="col-lg-12 col-form-label fw-semibold fs-6">
                                    <span className="me-1 text-gray-500">{t("TikTok Account")}:</span>
                                    <span className="">
                                        {detail?.influencer?.unique_id ? "@" + detail?.influencer?.unique_id : ""}
                                        {
                                            detail?.influencer?.unique_id ?
                                                <button className="btn btn-link text-hover-primary ms-1 p-0" data-tooltip-id="my-tooltip"
                                                    data-tooltip-content={"Copy"}
                                                    onClick={() => navigator.clipboard.writeText(detail?.influencer?.unique_id)}
                                                >
                                                    <i className="ki-duotone ki-copy mb-1">
                                                    </i>
                                                </button>
                                            : ""
                                        }
                                    </span>
                                </label>
                                <label className="col-lg-12 col-form-label fw-semibold fs-6">
                                    <span className="me-1 text-gray-500">{t("Delivery Type")}:</span>
                                    <span className="">{detail?.seller_type?.name}</span>
                                </label>
                                <label className="col-lg-12 col-form-label fw-semibold fs-6">
                                    <span className="me-1 text-gray-500">{t("Tracked")}:</span>
                                    <span className=""></span>
                                </label>
                            </div>
                            <div className="col-lg-7">
                                <label className="col-lg-12 col-form-label fw-semibold fs-6">
                                    <span className="me-1 text-gray-500">{t("Main Category")}:</span>
                                    <span className="">{detail?.category}</span>
                                </label>
                                <label className="col-lg-12 col-form-label fw-semibold fs-6">
                                    <span className="me-1 text-gray-500">{t("Price Distribution")}:</span>
                                    <span className="">{detail?.min_price} - {detail?.max_price}, Mean price {detail?.price}</span>
                                </label>
                                <label className="col-lg-12 col-form-label fw-semibold fs-6">
                                    <span className="me-1 text-gray-500">{t("Main Sales Methods")}:</span>
                                    <span className="">{detail?.sales_flag?.name}</span>
                                </label>
                            </div>
                        </div>
                        <div className="row col justify-content-end">
                            <div className="col-lg-2 me-1 mb-1">
                                <div className="bg-light-info al-border-radius-8 min-w-125px py-3 px-4 me-6 mb-3 h-100 d-flex flex-column justify-content-center align-items-center text-center">
                                    <i className="ki-outline ki-like fs-3 text-info me-2 mb-2"></i>
                                    <div className="fs-2 fw-bold counted">{detail?.sale_cnt}</div>
                                    <div className="fw-semibold fs-6 text-gray-500">{t("Total Sales")}</div>
                                </div>
                            </div>
                            <div className="col-lg-2 me-1 mb-1">
                                <div className="bg-light-info al-border-radius-8 min-w-125px py-3 px-4 me-6 mb-3 h-100 d-flex flex-column justify-content-center align-items-center text-center">
                                    <i className="ki-outline ki-wallet fs-3 text-info me-2 mb-2"></i>
                                    <div className="fs-2 fw-bold counted">{detail?.gmv_amt}</div>
                                    <div className="fw-semibold fs-6 text-gray-500">{t("Total GMV")}</div>
                                </div>
                            </div>
                            <div className="col-lg-2 me-1 mb-1">
                                <div className="bg-light-info al-border-radius-8 min-w-125px py-3 px-4 me-6 mb-3 h-100 d-flex flex-column justify-content-center align-items-center text-center">
                                    <i className="ki-outline ki-award fs-3 text-info me-2 mb-2"></i>
                                    <div className="fs-2 fw-bold counted">{detail?.total_ifl_cnt}</div>
                                    <div className="fw-semibold fs-6 text-gray-500">{t("Total Influencers")}</div>
                                </div>
                            </div>
                            <div className="col-lg-2 me-1 mb-1">
                                <div className="bg-light-info al-border-radius-8 min-w-125px py-3 px-4 me-6 mb-3 h-100 d-flex flex-column justify-content-center align-items-center text-center">
                                    <i className="ki-outline ki-to-right fs-3 text-info me-2 mb-2"></i>
                                    <div className="fs-2 fw-bold counted">{detail?.total_video_cnt}</div>
                                    <div className="fw-semibold fs-6 text-gray-500">{t("Total Videos")}</div>
                                </div>
                            </div>
                            <div className="col-lg-2">
                                <div className="bg-light-info al-border-radius-8 min-w-125px py-3 px-4 me-6 mb-3 h-100 d-flex flex-column justify-content-center align-items-center text-center">
                                    <i className="ki-outline ki-wifi-home fs-3 text-info me-2 mb-2"></i>
                                    <div className="fs-2 fw-bold counted">{detail?.total_live_cnt}</div>
                                    <div className="fw-semibold fs-6 text-gray-500">{t("Total lives")}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="">
                <div className="card-body pt-0 pb-0">
                    <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "basic" })}  to={"/admin/spy-advanced/shops/"+seller_id} onClick={(e) => { onClick("basic"); }}>
                                {t("Basic")}
                            </Link>
                        </li>
                        {/* <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "video_analysis" })}  to={"/admin/spy-advanced/shops/"+seller_id} onClick={(e) => { onClick("video_analysis"); }}>
                                {t("Video analysis")}
                            </Link>
                        </li>
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "live_analysis" })}  to={"/admin/spy-advanced/shops/"+seller_id} onClick={(e) => { onClick("live_analysis"); }}>
                                {t("Live analysis")}
                            </Link>
                        </li> */}
                    </ul>
                </div>
                {
                    tab === "basic" ? 
                        <Fragment>
                            <Overview overview={overview} sales_trending_cnt={sales_trending_cnt} sales_trending_gmv_amt={sales_trending_gmv_amt} influencer_trending={influencer_trending} video_trending={video_trending} filter={filter} setFilter={setFilter} />
                            <Saleschannels sale_channel={sale_channel} />
                            <Productsdistribution product_distribution={product_distribution} product_prices={product_prices} filter={filter} />
                            <Productlist products_filters={products_filters} />
                            <Influencerlist />
                            <Videolist />
                        </Fragment>
                    : ""
                }
            </div>
        </Fragment>
    );
};

export default connect(null, { getShopDetail })(ShopDetail);
